import { dateFormatter, getEventImageUrl } from "../../../utils/Helper";
import { useNavigate } from "react-router-dom";
import useHttpHook from "../../../Hooks/HttpHook";
import { RemoveFromWishlist } from "../../../utils/ApiConstant";

const Wishlist = ({ event, onRemoved }) => {
  const [loading, sendRequest] = useHttpHook();
  const navigate = useNavigate();
  const eventData = event?.[0] || {};
  const imagePath = eventData.mainimage?.[0]?.path || "";
  const imageUrl = imagePath
    ? getEventImageUrl(
        imagePath,
        "https://placehold.co/700x900/0b1020/eaf0ff?text=Event"
      )
    : "https://placehold.co/700x900/0b1020/eaf0ff?text=Event";

  const startDate = eventData.eventTiming?.startDate || eventData.eventTiming;

  const openEventDetails = (e) => {
    e.preventDefault();
    navigate(`/event-details/${eventData._id}?redirectUrl=/wishlist`);
  };

  const wishlistAction = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const response = await sendRequest(RemoveFromWishlist, {
      method: "post",
      data: { eventId: eventData._id },
    });

    if (response.status === 1) {
      onRemoved?.(eventData._id);
    }
  };

  return (
    <article className="event-wishlist-card" role="listitem" aria-label={eventData.title}>
      <div className="event-wishlist-card-media-wrap">
        <a
          className="event-wishlist-card-media-link"
          href={`/event-details/${eventData._id}`}
          onClick={openEventDetails}
          aria-label={`View ${eventData.title}`}
        >
          <div className="event-wishlist-card-media">
            <img
              className="event-wishlist-card-image-bg"
              src={imageUrl}
              alt=""
              loading="lazy"
              aria-hidden="true"
            />
            <img
              className="event-wishlist-card-image"
              src={imageUrl}
              alt={eventData.title || "Event"}
              loading="lazy"
            />
          </div>
        </a>
        <button
          disabled={loading}
          title="Remove from wishlist"
          className="event-wishlist-fav is-active"
          onClick={wishlistAction}
          type="button"
          aria-label={`Remove ${eventData.title} from wishlist`}
        >
          <i className="bi bi-heart-fill" aria-hidden="true"></i>
        </button>
        {eventData.category && (
          <span className="event-wishlist-tag">{eventData.category}</span>
        )}
      </div>

      <a
        className="event-wishlist-card-body-link"
        href={`/event-details/${eventData._id}`}
        onClick={openEventDetails}
      >
        <div className="event-wishlist-card-body">
          <p className="event-wishlist-date">{dateFormatter(startDate)}</p>
          <h3 className="event-wishlist-title-card">{eventData.title}</h3>
          <div className="event-wishlist-location">
            <i className="bi bi-geo-alt" aria-hidden="true"></i>
            <span>{eventData.location?.address || "Location not available"}</span>
          </div>
        </div>
      </a>
    </article>
  );
};

export default Wishlist;
